import type { ReactNode } from "react";

import { HaNContext, HaNFilterBarContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { useHaNLayoutMode } from "../../state/layout/useHaNLayoutMode";

// Over the map on wide screens and in the phone map view; at the top of the list in the phone list view
export const HaNFilterBar = ({ children }: { children: ReactNode }) => {
  const layoutMode = useHaNLayoutMode();
  const { mapListView } = useRequiredContext(HaNContext);

  const areFiltersTransparent = layoutMode === "mobile" && mapListView.view === "list";

  return (
    <HaNFilterBarContext.Provider value={{ areFiltersTransparent }}>
      <div className="relative z-10 col-start-2 row-[1/-1] min-w-0 self-start px-5 pt-4 empty:hidden max-sm:col-start-1 max-sm:row-[4/5] max-sm:group-data-[map-list-view=list]/han:pb-4 max-sm:group-data-[map-list-view=map]/han:row-[4/6]">
        {children}
      </div>
    </HaNFilterBarContext.Provider>
  );
};
